/**
 * Configuração de URLs para desenvolvimento e produção
 * Permite definir facilmente as URLs das aplicações React e Angular
 */

export const APP_CONFIG = {
  development: {
    react: {
      baseUrl: 'http://localhost:8080',
      routePrefix: '/v2'
    },
    angular: {
      baseUrl: 'http://localhost:4200',
      routePrefix: ''
    }
  },
  production: {
    react: {
      baseUrl: window.location.origin,
      routePrefix: '/v2' // Em produção, React tem prefixo /v2
    },
    angular: {
      baseUrl: window.location.origin,
      routePrefix: ''
    }
  }
};

export type Environment = 'development' | 'production';
export type AppType = 'react' | 'angular';
